import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Modal from '../ui/Modal';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';
import config from '../../config';
import {getConversationDetails} from '../../services/chat/api';
import ConversationDetails from './ConversationDetails';
import {generalModalStyles, hasManagementPermission} from '../../utils/General';
import ChatIcon from "../../assets/icons/ChatIcon";

Modal.setAppElement('#root');

const ChatMoreInfoModal = ({
                               isOpen,
                               onRequestClose,
                               conversation,
                               useProvidedDetails = false,
                               initialTab,
                               company,
                               user
                           }) => {
    const [fetchedDetails, setFetchedDetails] = useState(null);
    const conversationId = conversation && conversation.id;

    useEffect(() => {
        if (!isOpen || useProvidedDetails || !conversationId) return;

        let active = true;
        setFetchedDetails(null);
        getConversationDetails(conversationId).then(data => {
            if (active) setFetchedDetails(data);
        }).catch(() => {
            if (active) setFetchedDetails(null);
        });

        return () => {
            active = false;
        };
    }, [isOpen, useProvidedDetails, conversationId]);

    const conversationDetails = useProvidedDetails ? conversation : fetchedDetails;

    return (
        <Modal footer={null} closeTimeoutMS={config.closeTimeoutMS}
               isOpen={isOpen}
               style={generalModalStyles.convHeaderModalStyles}
               title={<Translate text="conversationDetails"/>}
               description={<Translate text="conversationDetailsDescription"/>}
               headerIcon={<ChatIcon width={20} height={20}/>}
               headerSeparator
               onRequestClose={onRequestClose}>
            {conversationDetails && (
                <ConversationDetails
                    conversationDetails={conversationDetails}
                    initialTab={initialTab}
                    parentCompanyId={company && company.parentCompanyId ? company.parentCompanyId : company.id}
                    canViewOperatorProfile={user && user.authorities && hasManagementPermission(user)}
                />
            )}
        </Modal>
    );
};

ChatMoreInfoModal.propTypes = {
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    conversation: PropTypes.object.isRequired,
    useProvidedDetails: PropTypes.bool,
    initialTab: PropTypes.string,
    company: PropTypes.object,
    user: PropTypes.object,
};

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(ChatMoreInfoModal);



// WEBPACK FOOTER //
// ./src/components-new/general/ChatMoreInfoModal.jsx